// extracted by mini-css-extract-plugin
module.exports = {"section":"DigitalKeysAvailable_section__OTis0","container":"DigitalKeysAvailable_container__p_uJq","label":"DigitalKeysAvailable_label__ELl4a"};